import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

export const MessageBoxStyled = styled(FlexContainer)`
  width: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.highlight.variant6};
  padding: 14px 10px;
  color: ${({ theme }) => theme.colors.primary.variant15};
`;

export const MessageBoxContentStyled = styled.div`
  width: 100%;
  max-height: 70px;
  overflow-y: auto;
`;

export const MessageRowStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;
